'use strict';

class UsersListController {
  constructor($log,
              $scope,
              $q,
              $filter,
              $state,
              $stateParams,
              $translate,
              utils,
              OrganizationService,
              SubscriptionsService,
              UsersService,
              TagsService,
              VirtualPaginator,
              PermissionsService,
              ToastsService) {

    // #region Define fields
    const $t = $filter('translate');
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';

    $scope.paginator = null;
    $scope.loading = false;
    $scope.thereAreMoreItems = false;
    $scope.orgStatuses = [];
    $scope.orgDeviceTypes = [];
    $scope.userInfo = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);
    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.allOrgs = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);
    $scope.orgAdmins = [];
    $scope.timeFormatStr = $t('datetime.mdyHM12');

    $scope.canCreateUserAndLocation = PermissionsService.canICreateUserAndLocation();
    $scope.canCreateMessage = PermissionsService.canICreateMessage();

    // Batch editing fields
    $scope.isSelectMode = false;
    $scope.isSelectModeClickCount = 0;
    $scope.selectedUsers = [];

    const REQUEST_LIMIT = 100;
    const FILTER_LOCAL_STORAGE_KEY = 'Filter-Users-' + $scope.orgInfo.id;
    // #endregion

    // Put on scope only the stuff we really need there
    angular.extend($scope, {
      showMoreTags: showMoreTags,
      isAdminUser: isAdminUser,
      selectOrgUser: selectOrgUser,
      isUserEditable: isUserEditable,

      // Filter
      search: search,
      toggleFilter: toggleFilter,
      closeFilter: closeFilter,
      resetFilters: resetFilters,
      isFilterDirty: isFilterDirty,
      applyFilter: applyFilter,
      filterByTag: filterByTag,
      filterInputKeyPress: filterInputKeyPress,
      toggleSearchWild: toggleSearchWild,
      toggleSearchById: toggleSearchById,

      // Batch editing related
      toggleSelectionMode: toggleSelectionMode,
      toggleUserSelection: toggleUserSelection,
      isSelected: isSelected,
      toggleBatchEditPanel: toggleBatchEditPanel,
      closeBatchEditPanel: closeBatchEditPanel,
      onBatchApplyButtonClick: onBatchApplyButtonClick,
    });

    // Run initialization routine
    init();

    // #region Main Methods

    function init() {

      // Initialize filter
      $scope.filter = {};
      $scope.filter.searchVal = $stateParams.searchBy;
      if ($scope.filter.searchVal == null) {
        initFilterFromCache();
      }

      saveFilter();
      $scope.$watch('filter', function() {
        // saveFilter();
        // we save filter only after it was applied
      }, true);

      initBatchEditPanel();

      // Execute all promises
      $q.all([
        getPopularTags(),
        initSubscriptions()
      ])
        .then(function() {
          $scope.paginator = new VirtualPaginator(getOrgUsers);
          $scope.paginator.sortBy = 'creationDateMs';
          $scope.paginator.sortByReverse = true;

          // Get child organizations if they are exist
          $scope.childOrgs = !$scope.orgInfo.parentId
            ? utils.getChildOrganizations($scope.allOrgs, $scope.orgInfo.id)
            : [];
        });
    }

    function initSubscriptions() {
      let brand = utils.getBrandName($scope.orgInfo.id, $scope.allOrgs);
      return SubscriptionsService.getOrganizationSubscriptions($scope.orgInfo.id, brand)
        .then((subscriptions) => {
          $scope.orgSubscriptions = subscriptions;
        });
    }

    function isAdminUser(user) {
      return utils.checkAdminRights(user);
    }

    function showMoreTags($event, user) {
      $event.stopPropagation();
      $scope.selectOrgUser(user, 'tags');
    }

    function getPopularTags() {
      let tagType = 1; // User tags
      return TagsService.getPopularTags($scope.orgInfo.id, tagType, 100)
        .then(function(data) {
          $scope.tags = data.tags;
          return data;
        });
    }

    function getParameters() {
      let params = {
        getTags: true,
        sortCollection: 'users',
        sortBy: 'creationDateMs',
        sortOrder: 'desc'
      };
      if ($scope.filter.searchVal) {
        if ($scope.filter.searchById) {
          params.userId = $scope.filter.searchVal;
        } else {
          params.searchBy = $scope.filter.searchVal + '*';
        }
      }
      if ($scope.filter.selectedStatusId) {
        params.organizationStatus = $scope.filter.selectedStatusId;
      }
      if ($scope.filter.selectedTagStr) {
        params.searchTag = $scope.filter.selectedTagStr;
      }
      if ($scope.filter.selectedDeviceTagStr) {
        params.searchDeviceTag = $scope.filter.selectedDeviceTagStr;
      }
      if ($scope.filter.searchAddress) {
        params.searchAddress = $scope.filter.searchAddress;
      }
      if ($scope.filter.selectedSubscriptionId) {
        params.servicePlanId = $scope.filter.selectedSubscriptionId;
      }
      if ($scope.filter.selectedDeviceTypeId) {
        params.deviceType = $scope.filter.selectedDeviceTypeId;
      }

      // Always limit requests
      params.limit = REQUEST_LIMIT;

      return params;
    }

    function getOrgUsers() {
      $scope.loading = true;
      let organizationId = $scope.filter.searchWild || $scope.filter.searchById ? void 0 : ($scope.filter.selectedChildOrgId
        ? $scope.filter.selectedChildOrgId
        : $scope.orgInfo.id);

      return UsersService.getUsersByParams(organizationId, getParameters())
        .then(function(data) {
          $scope.loading = false;
          if (!data.users) {
            $scope.thereAreMoreItems = false;
            return;
          }
          // Limiting request message
          $scope.thereAreMoreItems = data.collectionTotalSize && data.collectionTotalSize === REQUEST_LIMIT;

          return data.users;
        }, err => {
          $scope.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
        });
    }

    function selectOrgUser(user, tabName) {
      //Just select user for edit if we are in the 'select users' mode.
      if ($scope.isSelectMode) {
        if (isUserEditable(user)) {
          toggleUserSelection(user);
        }
        return;
      }

      utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);

      if (isUserEditable(user)) {
        $state.go('main.users.edit', { tab: tabName });
      } else {
        $state.go('main.users.view', { tab: tabName });
      }
    }

    function isUserEditable(user) {
      return PermissionsService.canIEditUser(user);
    }

    // #endregion

    // #region Filter Methods

    /**
     * Is filter has some values set
     * @param {boolean} filterOnly To check only filter without search value
     * @return {boolean}
     */
    function isFilterDirty(filterOnly) {
      if (!$scope.filter) {
        return false;
      }
      let tempFilter = angular.copy($scope.filter);
      if (filterOnly) {
        tempFilter.searchVal = void 0;
        tempFilter.searchWild = void 0;
        tempFilter.searchById = void 0;
      }
      return Object.keys(tempFilter)
        .some(key => !!tempFilter[key]);
    }

    function toggleFilter() {
      $('#filter').transition('fade down');
    }

    function closeFilter() {
      let visible = $('#filter').transition('is visible');
      if (visible) {
        $('#filter').transition('hide');
      }
    }

    function resetFilters(isSearchWildTriggered) {
      $scope.filter = !isSearchWildTriggered ? {
        searchVal: $scope.filter.searchVal,
        searchById: !!$scope.filter.searchById,
      } : {
        searchVal: $scope.filter.searchVal,
        searchWild: !!$scope.filter.searchWild,
        searchById: !!$scope.filter.searchById,
        searchAddress: $scope.filter.searchAddress,
        selectedSubscriptionId: $scope.filter.selectedSubscriptionId,
        selectedTagStr: $scope.filter.selectedTagStr,
      };
      applyFilter();
    }

    function saveFilter() {
      resetBatchEditFormValues();
      toggleSelectionMode(true);
      if (!$scope.filter.searchVal) {
        $scope.filter.searchVal = void 0;
      }
      if (!$scope.filter.searchAddress) {
        $scope.filter.searchAddress = void 0;
      }
      $scope.filter.searchWild = !!$scope.filter.searchWild;
      $scope.filter.searchById = !!$scope.filter.searchById;
      utils.setStorageItem(FILTER_LOCAL_STORAGE_KEY, $scope.filter);
    }

    function initFilterFromCache() {
      $scope.filter = utils.getStorageItem(FILTER_LOCAL_STORAGE_KEY) || {};
    }

    function search() {
      if ($scope.loading || !$scope.paginator) {
        return;
      }
      closeFilter();
      saveFilter();
      $scope.paginator.reload();
    }

    function applyFilter() {
      if ($scope.loading || !$scope.paginator) {
        return;
      }
      closeFilter();
      saveFilter();
      $scope.paginator.reload();
    }

    function filterInputKeyPress(keyEvent) {
      if (keyEvent.which === 13) {
        applyFilter();
      }
    }

    function filterByTag($event, tag) {
      $event.stopPropagation();
      $scope.filter.selectedTagStr = tag.tag;
      applyFilter();
    }

    /* Toggle on/off organization-free search */
    function toggleSearchWild() {
      $scope.filter.searchWild = !$scope.filter.searchWild;
      $scope.filter.searchById = false;
      toggleSelectionMode(true);
      resetFilters(true);
    }

    /* Toggle on/off search by user ID */
    function toggleSearchById() {
      $scope.filter.searchById = !$scope.filter.searchById;
      $scope.filter.searchWild = false;
      toggleSelectionMode(true);
      resetFilters();
    }

    // #endregion

    // #region Batch Editing Methods

    function initBatchEditPanel() {
      $scope.$watchGroup(['selectedUsers', 'selectedTagsForBatchEdit'], () => {
        if (!$scope.selectedUsers || $scope.selectedUsers.length === 0) {
          $scope.canBatchEditTags = false;
          $scope.batchEditTagsMsg = '';
          $scope.isBatchEditApplyEnabled = false;
          return;
        }

        $scope.canBatchEditTags = true;
        $scope.batchEditTagsMsg = '';

        $scope.isBatchEditApplyEnabled = !!$scope.selectedUsers
          && $scope.selectedUsers.length > 0
          && $scope.canBatchEditTags
          && !!$scope.selectedTagsForBatchEdit
          && $scope.selectedTagsForBatchEdit.length > 0;
      }, true);
    }

    function toggleSelectionMode(resetToDefault) {
      if (!$scope.isSelectMode) {
        $scope.isSelectMode = true;
      }
      $scope.isSelectModeClickCount++;

      // To allow to select all via second click, we need to 'switch off' selection mode only on the third click
      if ($scope.isSelectModeClickCount === 2) {
        $scope.selectedUsers = [].concat($scope.paginator.currentPageItems);
      }
      if (resetToDefault || $scope.isSelectModeClickCount === 3) {
        $scope.isSelectMode = false;
        $scope.isSelectModeClickCount = 0;
        if ($('#batchEdit').hasClass('visible')) {
          $scope.toggleBatchEditPanel();
        }
      }

      if (!$scope.isSelectMode) {
        // After we switched off the selection mode
        $scope.selectedUsers.length = 0; // Clearing the array of selected users keeping the reference intact
      }
    }

    function toggleUserSelection(user, event) {
      if (!$scope.selectedUsers) {
        $scope.selectedUsers = [];
      }
      let currentUsers = angular.copy($scope.selectedUsers);
      if (isSelected(user)) {
        $scope.selectedUsers = currentUsers.filter(l => l.id !== user.id);
      } else {
        currentUsers.push(user);
        $scope.selectedUsers = currentUsers;
      }
      if (event) {
        event.stopPropagation();
      }
    }

    function isSelected(user) {
      return $scope.selectedUsers.some((u, i) => u.id === user.id);
    }

    function toggleBatchEditPanel() {
      $('#batchEdit').transition('fade down');
    }

    function closeBatchEditPanel() {
      let opened = $('#batchEdit').transition('is visible');
      if (opened) {
        $('#batchEdit').transition('hide');
      }
    }

    function onBatchApplyButtonClick() {
      if ($scope.loading || !$scope.isBatchEditApplyEnabled || !$scope.selectedUsers || $scope.selectedUsers.length === 0) {
        return;
      }

      $('#batch-edit-user-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: function() {
            $scope.$applyAsync(() => {
              updateSelectedUsers();
            });
          }
        }).modal('show');
    }

    function updateSelectedUsers() {
      if ($scope.loading || !$scope.isBatchEditApplyEnabled || !$scope.selectedUsers || $scope.selectedUsers.length === 0) {
        return;
      }

      $scope.loading = true;
      if ($scope.selectedTagsForBatchEdit && $scope.selectedTagsForBatchEdit.length > 0 && $scope.canBatchEditTags) {

        const tagsToApply = [];
        $scope.selectedUsers.forEach(user => {
          $scope.selectedTagsForBatchEdit.forEach(tag => {
            tagsToApply.push({
              type: 1,
              tag: tag,
              id: user.id
            });
          });
        });

        return TagsService.saveTags($scope.orgInfo.id, tagsToApply)
          .then(() => {
            $scope.loading = false;
            resetBatchEditFormValues();
            ToastsService.success(null, $t('users.list.batch.tags-add-success'), 'success', 2);
            toggleSelectionMode(true); // Close the batch edit panel after operation
            $scope.paginator.reload();
          }, (err) => {
            $scope.loading = false;
            resetBatchEditFormValues();
            utils.handleApiError(err);
            toggleSelectionMode(true); // Close the batch edit panel after operation
            $scope.paginator.reload();
          });
      } else {
        $scope.loading = false;
      }
    }

    function resetBatchEditFormValues() {
      $scope.selectedUsers = [];
      $scope.selectedTagsForBatchEdit = undefined;
      $scope.selectedTagsForBatchEditObj = undefined;
    }

    // #endregion
  }
}

export default angular
  .module('main.usersList.controller', [])
  .controller('UsersListController', UsersListController)
  .name;
